// extracted by mini-css-extract-plugin
export default {"Quiz":"quiz_Quiz__Yrery","content":"quiz_content__5Y-zq"};